import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M20 3h-1V1h-2v2H7V1H5v2H4a2 2 0 00-2 2v16c0 1.1.9 2 2 2h16a2 2 0 002-2V5a2 2 0 00-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z" }));
export {
  a as ReactComponent
};
